module.exports = __webpack_public_path__ + "static/media/stofferingen-26.870c3010.jpg";